
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const switchLanguage = (lang) => {
  i18n.changeLanguage(lang);
};


export default function PrivacyPolicyUa() {
  const { lang } = useParams();
  const { t, i18n } = useTranslation();

    return (
        <div className={` inset-0 top-[150px] max-w-7xl mt-20`}>
            <>

                <>
                    <header className="entry-header">
                        <h1 className="text-[#2a7a2a] text-center text-4xl">
                            Політика конфіденційності
                        </h1>
                    </header>
                    <p
                        style={{
                            fontWeight: "bold",
                            lineHeight: "1.2",
                            fontSize: 22,
                            color: "#494e53ff",
                        }}
                    >
                        <span style={{ fontSize: 14 }}>Останнє оновлення: 02.03.2024.</span>
                        <br />
                        <span style={{ fontSize: 14 }}>Дата введення в дію: 02.03.2024.</span>
                    </p>
                    <br /><p>
                        Ця Політика конфіденційності описує, як SerhiiShevchenko.com («Компанія»,
                        «ми», «веб-сайт») збирає, використовує, обробляє та поширює Вашу інформацію,
                        включаючи Персональні дані (як визначено нижче), які використовуються для
                        доступу до цього Веб-сайту. Ми не використовуватимемо Вашу інформацію та не
                        передаватимемо її нікому, крім випадків, описаних у цій Політиці
                        конфіденційності. Використання інформації, зібраної через наш веб-сайт,
                        обмежується цілями, передбаченими цією Політикою конфіденційності, а також
                        нашими Умовами використання, якщо Ви є клієнтом.
                    </p>

                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Згода
                        </strong>
                        <br /></h2>
                    <p>
                        Користуючись нашим веб-сайтом, Ви тим самим погоджуєтеся з нашою Політикою
                        конфіденційності та погоджуєтеся з її умовами.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Неперсональні дані
                        </strong>
                        <br /></h2>
                    <p>
                        Ми збираємо та використовуємо інформацію про Вашу взаємодію з веб-сайтом у
                        спосіб і формат, які не ідентифікують Вас як особу («Неперсональні дані»).
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Використання «Cookies»
                        </strong>
                        <br /></h2>
                    <p>
                        Як і багато веб-сайтів, коли Ви відвідуєте SerhiiShevchenko.com, ми можемо
                        використовувати файли cookie, щоб ідентифікувати Ваш браузер і бачити, як Ви
                        використовуєте наш веб-сайт (наприклад, сторінки, які Ви переглядаєте,
                        посилання, які Ви натискаєте, та інші Ваші дії). Ви можете вимкнути файли
                        cookie в налаштуваннях власного веб-браузера. Однак вимкнення файлів cookie
                        може погіршити Ваш досвід роботи на нашому веб-сайті, а деякі функції можуть
                        не працювати належним чином.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Файли журналів
                        </strong>
                        <br /></h2>
                    <p>
                        Інформація про файл журналу автоматично надсилається Вашим браузером кожного
                        разу, коли Ви відкриваєте веб-сторінку. Інформація, зібрана файлами журналу,
                        включає адреси Інтернет-протоколу (IP), тип браузера, Інтернет-провайдера
                        (ISP), позначку дати та часу, сторінки переходу/виходу та, можливо,
                        кількість кліків. Вони не пов’язані з будь-якою інформацією, яка дозволяє
                        ідентифікувати особу. Метою інформації є аналіз тенденцій, адміністрування
                        сайту, відстеження переміщень користувачів на веб-сайті та збір
                        демографічної інформації.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Веб-маяки
                        </strong>
                        <br /></h2>
                    <p>
                        Певні розділи нашого Веб-сайту, ресурси та наші електронні листи можуть
                        містити невеликі електронні файли, відомі як веб-маяки (також називаються
                        чистими gif, піксельними тегами та однопіксельними зображеннями gif), які
                        дозволяють Компанії, наприклад, підраховувати користувачів, які відвідали ці
                        сторінки або відкриті електронні листи та для іншої пов’язаної статистики
                        веб-сайту (наприклад, запис популярності певного розділу та перевірка
                        цілісності системи та сервера).
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Особисті дані
                        </strong>
                        <br /></h2>
                    <p>
                        Ми збираємо Вашу особисту інформацію, щоб ми могли надати Вам позитивний
                        досвід під час використання нашого веб-сайту або вмісту. Зазвичай особиста
                        інформація, яку Вас просять надати, і причини, чому Вас просять надати певну
                        інформацію, будуть вказані Вам у момент запиту цієї особистої інформації.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Ми можемо збирати:
                        </strong>
                        <br /></h2>
                    <ol style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                        <li>
                            Ім’я та адреса електронної пошти, щоб ми могли надсилати вам нашу розсилку
                            – ви підтверджуєте свою згоду на це, надаючи цю інформацію нам у наших
                            контактних формах.
                        </li>
                        <li>
                            Платіжна інформація, включаючи ім’я, адресу та дані кредитної картки, щоб
                            ми могли обробити оплату для доставки наших продуктів або послуг вам
                            відповідно до наших договірних зобов’язань.
                        </li>
                        <li>
                            Ім’я, адресу електронної пошти, вміст повідомлення та будь-яку іншу
                            інформацію, яку ви можете надати нам під час безпосереднього зв’язку з
                            нами, заповнивши нашу контактну форму. Ми можемо надсилати вам
                            маркетингові електронні листи з вашої згоди або якщо вважаємо, що маємо
                            законний інтерес зв’язатися з вами на основі вашого контакту чи запитання.
                        </li>
                    </ol>
                    <br /><p>
                        Зверніть увагу, що наведена вище інформація, яку Ви надаєте нам є
                        добровільною, і, надаючи нам цю інформацію, Ви даєте згоду на використання,
                        збір і обробку цих Персональних даних. Ви можете в будь-який момент
                        відмовитися або подати запит на видалення Ваших персональних даних,
                        зв’язавшись з нами за адресою {import.meta.env.VITE_MY_WORK_EMAIL}
                    </p>
                    <br /><p>
                        Якщо Ви вирішите не надавати нам певні Персональні дані, Ви не зможете
                        користуватись певними функціями і перевагами нашого Веб-сайту.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Інша інформація, яку ми збираємо
                        </strong>
                        <br /></h2>
                    <p>
                        Ми дозволяємо стороннім постачальникам використовувати файли cookie або
                        подібні технології для збору інформації про вашу діяльність на нашому Сайті
                        у веб-браузері. Наприклад, ми використовуємо Google Analytics, службу
                        веб-аналітики від Google, Inc. (“Google”). Google Analytics використовує
                        файли cookie, щоб допомогти нам проаналізувати, як Ви використовуєте наш
                        веб-сайт і вміст, щоб ми могли краще зрозуміти, який вміст вас цікавить, і
                        таким чином надавати Вам кращий вміст. Щоб дізнатися більше про те, як
                        Google використовує ці дані, перейдіть на сторінку{" "}
                        <a
                            href="https://policies.google.com/technologies/partner-sites"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            www.google.com/policies/privacy/partners/
                        </a>
                        . Ви можете дізнатися більше про те, як відмовитися від Google Analytics,
                        перейшовши на сторінку{" "}
                        <a
                            href="https://tools.google.com/dlpage/gaoptout"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            https://tools.google.com/dlpage/gaoptout
                        </a>
                        .
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Як ми використовуємо Вашу інформацію
                        </strong>
                        <br /></h2>
                    <p>
                        Ми можемо використовувати та розкривати Ваші персональні дані таким чином:
                    </p>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                        <li>
                            Для покращення, персоналізації та розширення нашого Веб-сайту і
                            пропозицій.
                        </li>
                        <li>Щоб зрозуміти та проаналізувати, як Ви використовуєте наш веб-сайт.</li>
                        <li>Для створення нових продуктів, послуг, характеристик та функцій.</li>
                        <li>
                            Для спілкування з Вами безпосередньо або через одного з наших партнерів,
                            зокрема для обслуговування клієнтів, щоб надавати Вам оновлення та іншу
                            інформацію, що стосується веб-сайту, наприклад нові функції, оновлення та
                            зміни в нашій Політиці конфіденційності, а також для маркетингових і
                            рекламних цілей.
                        </li>
                        <li>
                            Щоб ділитися цією інформацією з довіреними третіми сторонами як,
                            наприклад, нашим сервісом Email розсилок, щоб зв’язуватися з вами
                            електронною поштою, або з нашими мерчант акаунтами для обробки платежів,
                            обліковими записами Google для аналізу того, як Ви використовуєте наш
                            Веб-сайт, для показу реклами та з іншими нашими партнерами.
                        </li>
                        <li>
                            Для надання інформації представникам і консультантам, як-от адвокатам і
                            бухгалтерам, щоб допомогти нам дотримуватися вимог законодавства,
                            бухгалтерського обліку чи безпеки.
                        </li>
                        <li>
                            Для надсилання Вам інформаційного та рекламного контенту, який Ви можете
                            отримувати (або «підписатися»), наприклад, щоденні, щотижневі та щомісячні
                            електронні (Email) листи. Ви можете припинити отримання наших рекламних
                            електронних листів, дотримуючись інструкцій щодо скасування підписки, які
                            містяться в кожному електронному листі.
                        </li>
                    </ul>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Сторонні сайти та ресурси
                        </strong>
                        <br /></h2>
                    <p>
                        SerhiiShevchenko.com і його ресурси можуть містити численні посилання на
                        інші веб-сайти, чия політика конфіденційності може відрізнятися від нашої.
                        Якщо Ви надсилаєте Персональні дані на будь-який із цих сайтів, Ваша
                        інформація регулюється їхньою політикою конфіденційності. Ми рекомендуємо
                        Вам уважно читати політику конфіденційності будь-якого веб-сайту, який Ви
                        відвідуєте.
                    </p>
                    <br /><p>
                        Кожного разу, коли Ви добровільно надаєте свої персональні дані для
                        перегляду іншим користувачам в Інтернеті через цей веб-сайт, вони можуть
                        переглядатися, збиратися та використовуватися іншими, і тому ми не несемо
                        відповідальності за будь-яке несанкціоноване чи неналежне використання
                        інформації, яку Ви добровільно розповсюджуєте (наприклад, розповсюдження
                        коментарів до публікацій у блозі, опублікування публікацій в групі Facebook
                        або коментарі в каналі Telegram, яким ми керуємо, тощо).
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Подання, зберігання, обмін і передача персональних даних
                        </strong>
                        <br /></h2>
                    <p>
                        Ваша інформація, включно з Персональними даними, обробляється в робочих
                        офісах Компанії та в будь-яких інших місцях, де знаходяться сторони,
                        залучені до обробки (тобто наш хостинг-провайдер, сервіс Email розсилок,
                        платіжні процесори або члени команди). Це означає, що ця інформація може
                        передаватись на комп’ютери, розташовані за межами Вашого штату, провінції,
                        країни чи іншої урядової юрисдикції, де закони про захист даних можуть
                        відрізнятися від законів Вашої юрисдикції.
                    </p>
                    <br /><p>
                        Ваша згода з цією Політикою конфіденційності з подальшим наданням такої
                        інформації означає Вашу згоду на таку передачу.
                    </p>
                    <br /><p>
                        Компанія вживатиме всіх розумно необхідних заходів для забезпечення
                        безпечного поводження з Вашими даними відповідно до цієї Політики
                        конфіденційності, і жодна передача Ваших особистих даних організації чи
                        країні не здійснюватиметься, якщо не буде встановлено адекватних засобів
                        контролю, включаючи безпеку Ваших даних та іншої особистої інформації.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Безпека Ваших персональних даних
                        </strong>
                        <br /></h2>
                    <p>
                        Безпека Ваших особистих даних важлива для нас, але пам’ятайте, що жоден
                        метод передачі через Інтернет або метод електронного зберігання не є на 100%
                        безпечним. Незважаючи на те, що ми прагнемо використовувати комерційно
                        прийнятні засоби захисту Ваших персональних даних, ми не можемо гарантувати
                        їх абсолютну безпеку.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Випадки, коли ми зобов’язані надати Ваші Персональні дані
                        </strong>
                        <br /></h2>
                    <p>
                        SerhiiShevchenko.com розкриє Персональну інформацію, якщо цього вимагає
                        закон або повістка до суду, або якщо ми обґрунтовано вважаємо, що така дія
                        необхідна для (a) виконання закону та обґрунтованих запитів правоохоронних
                        органів; (b) для забезпечення виконання наших Умов надання послуг або
                        захисту безпеки чи цілісності нашого Веб-сайту; та/або (c) для реалізації чи
                        захисту прав, власності чи особистої безпеки SerhiiShevchenko.com, наших
                        Користувачів чи інших осіб.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Збереження
                        </strong>
                        <br /></h2>
                    <p>
                        Ми зберігаємо Ваші Персональні дані протягом мінімального періоду часу,
                        необхідного для цілей, викладених у цій Політиці конфіденційності. Ми
                        зберігатимемо та використовуватимемо Ваші персональні дані в обсязі,
                        необхідному для виконання наших юридичних зобов’язань (наприклад, якщо від
                        нас вимагається зберігати Ваші дані для дотримання чинного законодавства),
                        вирішення суперечок і забезпечення виконання наших юридичних угод і політик.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Як ви можете отримати доступ, оновити або видалити свої особисті дані
                        </strong>
                        <br /></h2>
                    <p>
                        Згідно з цією Політикою конфіденційності та законом, якщо Ви перебуваєте в
                        ЄС, Ви маєте право:
                    </p>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                        <li>
                            <strong>Запит на доступ до </strong>
                            <strong>В</strong>
                            <strong>аших особистих даних.</strong> Право на доступ, оновлення або
                            видалення інформації, яку ми маємо про Вас. Ви можете отримати доступ,
                            оновити або подати запит на видалення своїх персональних даних,
                            зв’язавшись з нами за адресою{" "}
                            <a href={`mailto:${import.meta.env.VITE_MY_WORK_EMAIL}`}>{import.meta.env.VITE_MY_WORK_EMAIL}</a>
                        </li>
                        <li>
                            <strong>Запит на виправлення персональних даних, які ми зберігаємо про </strong>
                            <strong>Вас.</strong> Ви маєте право на виправлення будь-якої неповної або
                            неточної інформації про Вас, яку ми маємо.
                        </li>
                        <li>
                            <strong>Заперечення проти обробки Ваших персональних даних.</strong> Це
                            право існує, якщо ми покладаємося на законний інтерес як правову основу
                            для нашої обробки, і є щось у Вашій конкретній ситуації, що змушує Вас
                            заперечувати проти нашої обробки Ваших персональних даних на цій підставі.
                            Ви також маєте право заперечити, якщо ми обробляємо Ваші персональні дані
                            для цілей прямого маркетингу.
                        </li>
                        <li>
                            <strong>Запит на</strong>
                            <strong> видалення Ваших персональних даних.</strong> Ви маєте право
                            попросити Нас видалити Ваші Особисті дані, якщо для нас немає вагомих
                            причин продовжувати їх обробку.
                        </li>
                        <li>
                            <strong>Запит на передачу Ваших персональних даних.</strong> Ми надамо Вам
                            або обраній Вами третій стороні Ваші персональні дані в структурованому,
                            широко використовуваному, читабельному форматі. Зауважте, що це право
                            поширюється лише на автоматизовану інформацію, на використання якої Ви
                            спочатку надали Нам згоду, або де Ми використовували інформацію для
                            виконання контракту з Вами.
                        </li>
                        <li>
                            <strong>Відкликання своєї згоди.</strong>
                            Ви маєте право відкликати свою згоду на використання
                            Ваших Персональних даних. Якщо Ви відкликаєте свою згоду, ми не зможемо
                            надати Вам доступ до певних функцій Сервісу.
                        </li>
                    </ul>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Виконання Ваших прав щодо захисту даних GDPR
                        </strong>
                        <br /></h2>
                    <p>
                        Ви можете скористатися своїми правами на доступ, виправлення, скасування та
                        заперечення, звернувшись до нас за адресою {import.meta.env.VITE_MY_WORK_EMAIL}.
                        Зверніть увагу, що ми можемо попросити Вас підтвердити Вашу особу, перш ніж
                        відповідати на такі запити. Якщо Ви зробите запит, ми зробимо все можливе,
                        щоб відповісти Вам якомога швидше.
                    </p>
                    <br /><h2 className="text-[#2a7a2a]">
                        <strong>
                            Політика конфіденційності дітей
                        </strong>
                        <br /></h2>
                    <p>
                        Ми не збираємо жодної інформації від осіб віком до 18 років відповідно до
                        COPPA (Закон про захист конфіденційності дітей в Інтернеті) і GDPR
                        (Загальний регламент ЄС щодо захисту даних). Наш веб-сайт і його вміст
                        призначені для осіб віком від 18 років.
                    </p>
                    <br />
                    <h2 className="text-[#2a7a2a]">
                        <strong>
                            Зміни до цієї Політики конфіденційності
                        </strong>
                        <br /></h2>
                    <p>
                        Час від часу ми можемо оновлювати нашу Політику конфіденційності. Періодично
                        переглядайте цю Політику конфіденційності. Продовження використання
                        будь-якої інформації, отриманої через Веб-сайт або на ньому, або його вмісту
                        після публікації змін та/або модифікацій означає Вашу згоду з переглянутою
                        Політикою конфіденційності. Ми залишаємо за собою право змінювати цю
                        Політику конфіденційності на веб-сайті в будь-який час без попередження. Ми
                        можемо повідомити Вас електронною поштою та/або у видному місці на нашому
                        Веб-сайті про деякі важливі зміни в нашій Політиці конфіденційності.
                    </p>
                    <br /><h2 className="text-[#2a7a2a]">
                        <strong>
                            Контролер даних і обробники
                        </strong>
                        <br /></h2>
                    <p>
                        Ми є контролерами даних, оскільки ми збираємо та використовуємо Ваші
                        Персональні дані. Ми використовуємо надійних третіх сторін як наших
                        обробників даних для технічних і організаційних цілей, зокрема для платежів
                        і маркетингу електронною поштою. Ми докладаємо розумних зусиль, щоб
                        переконатися, що наші обробники даних відповідають вимогам GDPR.
                    </p>
                    <br /><p>
                        Якщо у Вас виникли запитання щодо цієї Політики конфіденційності, напишіть
                        нам електронний лист на адресу {import.meta.env.VITE_MY_WORK_EMAIL}
                    </p>
                </>

            </>

        </div>
    );
}